<template>
  <div class="work_index">
     <div class="work_index_top" style="display: flex;justify-content: space-between;">
          
          <span>工作台</span>
          <span>数据管理</span>
     </div>
     <div class="work_index_item">
            <p>通讯录</p>
            <ul>
              <li>
               <router-link  class="work_option"  to="/director-workmaster-contacts">
                    <img  src="@/assets/work_menu/tongxunlu.png">
                    <div>通讯录</div>
               </router-link> 
              </li>

             
            </ul>
      </div>

      <div class="work_index_item">
            <p>我的工作</p>
            <ul  v-for="(group, index) in navs">
              <li  v-for="(item, index) in group" :key="index">
               <router-link  class="work_option"  :to="item.path">
                    <img  :src="item.icon">
                    <div>{{ item.title }}</div>
               </router-link> 
              </li>
            </ul>
      </div>

      <div class="work_index_item">
            <p>我的众包</p>
            <ul>
               <router-link class="work_option"  to="/bidding">
                    <img  src="@/assets/tender/zhaobiao.png">
                    <div>招标</div>
               </router-link> 
               <router-link class="work_option"  to="/tender">
                    <img  src="@/assets/tender/toubiao.png">
                    <div>投标</div>
               </router-link> 
               <router-link class="work_option"  to="/help-mine">
                    <img src="@/assets/tender/bangmang.png">
                    <div>我的帮忙</div>
               </router-link> 
               <router-link class="work_option"  to="/help-join">
                    <img src="@/assets/tender/bangzhu.png">
                    <div>帮助</div>
               </router-link> 

               <router-link class="work_option"  to="/help-join">
                    <img src="@/assets/tender/bangzhu.png">
                    <div>组团</div>
               </router-link> 

               <router-link class="work_option"  to="/help-join">
                    <img src="@/assets/tender/bangzhu.png">
                    <div>推广</div>
               </router-link> 

               <router-link class="work_option"  to="/help-join">
                    <img src="@/assets/tender/bangzhu.png">
                    <div>共享</div>
               </router-link> 


            </ul>
      </div>

  </div>
</template>

<script>
export default{
  
    data(){
          return{
            navs: [
              [
                {
                  title: "立项",
                  name: 'director-work-project',
                  path: '/director-work-project',
                  isChild: 1,
                  icon:require('@/assets/work_menu/lixiang.png'),
                  num: 0,
                  active: false
                },
                {
                  title: "需求",
                  name: 'director-work-demand',
                  path: '/director-work-demand',
                  icon:require('@/assets/work_menu/fabu.png'),

                  isChild: 1,
                  num: 0,
                  active: false
                },

                {
                title: "地址管理",
                name: 'director-work-address',
                path: '/director-work-address',
                icon:require('@/assets/work_menu/dizhi.png'),

                isChild: 1,
                num: 0,
                active: false
              },

              {
                title: "面试宝",
                name: 'director-audition', // 
                path: '/director-audition', // 
                icon:require('@/assets/work_menu/mianshi.png'),


                isChild: 0,
                num: 0,
                active: false
              },
              {
                title: "支付系统", // 不管
                name: 'director-pay',
                path: '/director-pay',
                icon:require('@/assets/work_menu/zhifu.png'),

                isChild: 0,
                num: 0,
                active: false
              },
              ],


              [
                {
                  title: "打卡",
                  name: 'director-workmaster-clock',
                  path: '/director-workmaster-clock',
                  icon:require('@/assets/work_menu/daka.png'),

                  isChild: 0,
                  num: 0,
                  active: false
                },


                {
                  title: "审批",
                  name: 'director-workmaster-approval',
                  path: '/director-workmaster-approval',
                  icon:require('@/assets/work_menu/shenpi.png'),

                  isChild: 0,
                  num: 0,
                  active: false
                },

                {
                  title: "汇报",
                  name: 'director-workmaster-report',
                  path: '/director-workmaster-report',
                  icon:require('@/assets/work_menu/huibao.png'),

                  isChild: 0,
                  num: 0,
                  active: false
                },

              ],
              
              
             /* {
                title: "工作通",
                name: 'director-workmaster',
                path: '/director-workmaster',
                isChild: 0,
                num: 0,
                active: false
              },
            
*/

              
              [
              {
                title: "报名审核",
                name: 'director-work-recruit-apply',
                path: '/director-work-recruit-apply',
                icon:require('@/assets/work_menu/baoming.png'),

                isChild: 1,
                num: 0,
                active: false
              },


              {
                title: "地址确认",
                name: 'director-work-recruit-address',
                path: '/director-work-recruit-address',
                icon:require('@/assets/work_menu/queren.png'),

                isChild: 1,
                num: 0,
                active: false
              },

              {
                title: "签写合同",
                name: 'director-work-recruit-contract',
                path: '/director-work-recruit-contract',
                icon:require('@/assets/work_menu/hetong.png'),

                isChild: 1,
                num: 0,
                active: false
              },


              {
                title: "结算评价",
                name: 'director-work-recruit-evaluate',
                path: '/director-work-recruit-evaluate',
                icon:require('@/assets/work_menu/pingjia.png'),

                isChild: 1,
                num: 0,
                active: false
              },
              ],

              [
              {
                title: "结算管理",
                name: 'director-work-address',
                path: '/director-work-address',
                icon:require('@/assets/work_menu/peixun.png'),

                isChild: 1,
                num: 0,
                active: false
              },

              {
                title: "客服管理",
                name: 'director-work-address',
                path: '/director-work-address',
                icon:require('@/assets/work_menu/peixun.png'),

                isChild: 1,
                num: 0,
                active: false
              },

              {
                title: "培训学院",
                name: 'director-work-address',
                path: '/director-work-address',
                icon:require('@/assets/work_menu/peixun.png'),

                isChild: 1,
                num: 0,
                active: false
              },


              ]
             
             

            ]
          };
    }
}

</script>

<style lang="scss" scoped>
.work_index{
    width: 1200px;
    margin: 0 auto;
}
.work_index_top{
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    font-weight: bolder;
    border-bottom: 1px solid #CCCCCC;
}

.work_index_item{
      margin-top: 38px;
 }
 .work_index_item ul{
      margin-top: 23px;
      display: flex;
      justify-content: start;
    flex-flow: wrap;

 }

 .work_index_item ul li{
      width: 200px;
      margin: 10px;
     
 }

 .work_index_item ul .work_option{
      min-width: 200px;
      height: 60px;
      margin-right: 19px;
      border: 1px solid #CCCCCC;
      border-radius: 10px;
      display: flex;
 }
 .work_index_item ul .work_option img{
      height: 39px;
      width: 39px;
      margin-top: 11px;
      margin-left: 13px;
 }
 .work_index_item ul .work_option div{
      margin-left: 20px;
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      font-weight: 500;
      user-select:none;
      color: #181818;
 }
</style>